var _desc, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgHarborWhiteWave(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "177px",
    height: "257px",
    viewBox: "0 0 177 257",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Harbor") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Page-1",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Harbor"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M104.385,42.551 L111.07,42.551 L111.07,28.404 L104.385,28.404 L104.385,42.551 Z M79.004,42.551 L85.689,42.551 L85.689,28.404 L79.004,28.404 L79.004,42.551 Z M88.324,42.551 L101.75,42.551 L101.75,28.404 L88.324,28.404 L88.324,42.551 Z M113.706,26.629 L117.7,26.629 L117.7,22.801 L115.805,22.801 L99.059,11.262 L99.018,11.262 L99.018,10.54 L100.363,10.54 L100.363,7.933 L97.451,7.905 L96.424,4.099 L96.424,0 L93.65,0 L93.65,4.099 L92.624,7.905 L89.711,7.933 L89.711,10.54 L91.057,10.54 L91.057,11.262 L91.015,11.262 L74.27,22.801 L72.375,22.801 L72.375,26.629 L76.369,26.629 L76.369,28.404 L76.369,42.551 L75.759,42.551 L75.759,53.314 L114.316,53.314 L114.316,42.551 L113.706,42.551 L113.706,28.404 L113.706,26.629 Z",
    id: "Fill-71",
    fill: "#014380"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M111.459,73.453 L113.234,73.453 L113.234,63.245 L111.459,63.245 L111.459,73.453 Z M102.583,73.453 L104.358,73.453 L104.358,63.245 L102.583,63.245 L102.583,73.453 Z M94.15,73.453 L95.925,73.453 L95.925,63.245 L94.15,63.245 L94.15,73.453 Z M85.274,73.453 L87.049,73.453 L87.049,63.245 L85.274,63.245 L85.274,73.453 Z M76.841,73.453 L78.616,73.453 L78.616,63.245 L76.841,63.245 L76.841,73.453 Z M62,58.709 L62,61.83 L71.32,64.743 L71.32,76.892 L117.7,76.892 L117.7,64.743 L118.754,64.743 L128.074,61.83 L128.074,58.709 L62,58.709 Z",
    id: "Fill-73",
    fill: "#014380"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M96.8126,81.3859 L117.6996,81.3859 L120.3356,106.8499 L113.7056,106.8499 C113.7056,106.8499 114.3156,85.2139 96.8126,81.3859",
    id: "Fill-74",
    fill: "#000000"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M102.1385,121.3301 L123.0255,121.3301 L125.6615,146.7941 L119.0315,146.7941 C119.0315,146.7941 119.6415,125.1581 102.1385,121.3301",
    id: "Fill-75",
    fill: "#000000"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M106.1329,162.6058 L127.0199,162.6058 L129.6559,188.0698 L123.0259,188.0698 C123.0259,188.0698 123.6359,166.4338 106.1329,162.6058",
    id: "Fill-76",
    fill: "#000000"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-77",
    fill: "#014380",
    points: "66.91 115.838 122.998 115.838 122.998 111.844 66.91 111.844"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-78",
    fill: "#014380",
    points: "63.082 157.113 126.993 157.113 126.993 153.119 63.082 153.119"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M59.0513,183.7254 C70.8083,201.2884 111.4613,208.4374 138.3623,213.1684 C146.3623,214.5754 153.2723,215.7904 157.9773,217.0384 C161.4033,217.9474 165.6653,220.2334 169.7483,223.0374 C170.7863,223.3944 171.3723,223.7304 171.3723,223.7304 L162.8633,206.2574 L147.0933,198.8334 L142.5413,204.1094 L141.9283,196.0674 L101.2803,184.6554 L92.8953,190.8064 L95.6033,181.6364 L80.9943,174.7554 L56.9213,178.7564 C57.2233,180.3184 57.8833,181.9814 59.0513,183.7254",
    id: "Fill-79",
    fill: "#000000"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Wave",
    transform: "translate(0.847170, 129.389045)",
    fill: "#FFFFFF"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M59.6686296,33.1758549 C59.6686296,33.1758549 45.8946296,43.1298549 54.8846296,56.5588549 C71.2676296,81.0298549 135.87263,86.1438549 156.10663,91.5108549 C166.09663,94.1598549 186.27163,107.052855 168.86463,120.648855 C168.86463,120.648855 173.24463,105.578855 154.45163,102.079855 C135.65863,98.5818549 67.6456296,91.0328549 57.7126296,88.0828549 C47.7786296,85.1328549 -2.12637044,67.0338549 11.6086296,28.3638549 C25.3426296,-10.3051451 75.2586296,1.79185485 75.2586296,1.79185485 C75.2586296,1.79185485 51.6776296,0.663854854 40.8256296,14.3328549 C29.9736296,28.0008549 35.9216296,45.0448549 35.9216296,45.0448549 C35.9216296,45.0448549 46.7936296,31.0438549 59.6686296,33.1758549",
    id: "Fill-80"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.69212956,37.7123549 C3.69212956,37.7123549 -4.37287044,65.6163549 34.5871296,85.4273549 C34.5871296,85.4273549 -13.4358704,80.0073549 3.69212956,37.7123549",
    id: "Fill-83"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M105.58263,99.5530549 C105.58263,99.5530549 136.55363,102.972055 147.50863,106.486055 C158.46363,109.999055 161.74563,113.538055 160.79363,118.148055 C159.84063,122.758055 145.57863,126.877055 145.57863,126.877055 C145.57863,126.877055 154.43063,121.255055 154.84363,117.279055 C155.25663,113.302055 157.77863,110.290055 105.58263,99.5530549",
    id: "Fill-84"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHarborWhiteWave);
export default __webpack_public_path__ + "static/media/harbor_white_wave.defb1d5fbe3e9a016dbf5f0bc4fb1c77.svg";
export { ForwardRef as ReactComponent };